var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _vm.loaded
    ? _c(
        "ItpBox",
        { staticClass: "items-spacing w-100", attrs: { alignItems: "center" } },
        [
          _c(
            "ItpBox",
            { attrs: { direction: "column" } },
            [
              _vm.resourceTitle
                ? _c("ItpText", {
                    staticClass: "mb-0",
                    attrs: { muted: "", text: _vm.resourceTitle }
                  })
                : _vm._e(),
              _vm._v(" "),
              _c("ItpText", {
                staticClass: "mb-0",
                attrs: { tag: "h5", text: _vm.resourceKey }
              })
            ],
            1
          ),
          _vm._v(" "),
          !_vm.entry.isNew && _vm.entry.invoice
            ? _c(
                "ItpBox",
                { attrs: { direction: "column" } },
                [
                  _c("ItpText", {
                    staticClass: "mb-0",
                    attrs: {
                      muted: "",
                      text: _vm._f("pgettext")(
                        "Invoice number",
                        "RegisterEntryHeader"
                      )
                    }
                  }),
                  _vm._v(" "),
                  _c("ItpText", {
                    staticClass: "mb-0",
                    attrs: { tag: "h4", text: _vm.entry.invoice.invoice_number }
                  })
                ],
                1
              )
            : _vm._e(),
          _vm._v(" "),
          _vm.entry.isNew && _vm.selectRegister
            ? _c("UcRegisterSelector", {
                attrs: {
                  companyId: _vm.entry.version.company_id,
                  toggleClass: "bg-white"
                },
                on: {
                  input: function($event) {
                    return _vm.evh_8358196963355853_input($event, {})
                  }
                },
                model: {
                  value: _vm.registerInfo,
                  callback: function($$v) {
                    _vm.registerInfo = $$v
                  },
                  expression: "registerInfo"
                }
              })
            : _vm._e(),
          _vm._v(" "),
          _vm.entry.isReadOnly
            ? _c(
                "h6",
                {
                  staticClass: "my-0 align-self-center",
                  attrs: {
                    title: _vm._f("pgettext")("Locked", "ResourceStatus")
                  }
                },
                [
                  _c(
                    "span",
                    {
                      staticClass:
                        "badge badge-secondary d-inline-flex align-items-center justify-content-start px-2",
                      style: _vm.b_6917646200545441_style
                    },
                    [
                      _c("ItpIcon", { attrs: { icon: _vm.$config.lockIcon } }),
                      _vm._v(" "),
                      _c("span", { staticClass: "ml-1" }, [
                        _vm._v(
                          "\n        " +
                            _vm._s(
                              _vm._f("pgettext")("Locked", "ResourceStatus")
                            ) +
                            "\n      "
                        )
                      ])
                    ],
                    1
                  )
                ]
              )
            : _vm._e(),
          _vm._v(" "),
          _vm.entry.void
            ? _c(
                "h6",
                {
                  staticClass: "my-0 align-self-center",
                  attrs: { title: _vm._f("pgettext")("Void", "ResourceStatus") }
                },
                [
                  _c(
                    "span",
                    {
                      staticClass:
                        "badge badge-warning d-inline-flex align-items-center justify-content-start px-2",
                      style: _vm.b_6424600534600827_style
                    },
                    [
                      _c("ItpIcon", { attrs: { icon: "eva:slash-fill" } }),
                      _vm._v(" "),
                      _c("span", { staticClass: "ml-1" }, [
                        _vm._v(
                          "\n        " +
                            _vm._s(
                              _vm._f("pgettext")("Void", "ResourceStatus")
                            ) +
                            "\n      "
                        )
                      ])
                    ],
                    1
                  )
                ]
              )
            : _vm._e(),
          _vm._v(" "),
          _c(
            "b-button-group",
            { staticClass: "ml-auto" },
            [
              !_vm.entry.isNew
                ? _c("ItpButton", {
                    staticClass: "ml-auto",
                    attrs: {
                      icon: "fa-sync-alt",
                      tooltip: _vm._f("gettext")("Reload"),
                      spinning: _vm.actions.reload.isRunning,
                      variant: "light"
                    },
                    on: {
                      click: function($event) {
                        $event.preventDefault()
                        $event.stopPropagation()
                        return _vm.evh_4576710983066270_clickPreventStop(
                          $event,
                          {}
                        )
                      }
                    }
                  })
                : _vm._e(),
              _vm._v(" "),
              !_vm.entry.isNew
                ? _c(
                    "b-dropdown",
                    {
                      staticClass: "border",
                      attrs: { right: "", variant: "light" }
                    },
                    [
                      _c("ItpIcon", {
                        staticClass: "mx-1",
                        attrs: { slot: "button-content", fa: "bars" },
                        slot: "button-content"
                      }),
                      _vm._v(" "),
                      !_vm.entry.isNew && _vm.entry.meta.can_lock
                        ? _c("ItpButton", {
                            attrs: {
                              "dropdown-item": "",
                              text: _vm._f("pgettext")("Lock", "BtnLockText"),
                              tooltip: _vm._f("pgettext")(
                                "Lock",
                                "BtnLockTooltip"
                              ),
                              variant: "default"
                            },
                            on: {
                              click: function($event) {
                                $event.preventDefault()
                                $event.stopPropagation()
                                return _vm.evh_2124730035910225_clickPreventStop(
                                  $event,
                                  {}
                                )
                              }
                            }
                          })
                        : _vm._e(),
                      _vm._v(" "),
                      !_vm.entry.isNew && _vm.entry.meta.can_unlock
                        ? _c("ItpButton", {
                            attrs: {
                              "dropdown-item": "",
                              text: _vm._f("pgettext")("Unlock", "BtnLockText"),
                              tooltip: _vm._f("pgettext")(
                                "Unlock",
                                "BtnLockTooltip"
                              ),
                              variant: "default"
                            },
                            on: {
                              click: function($event) {
                                $event.preventDefault()
                                $event.stopPropagation()
                                return _vm.evh_1972474632001399_clickPreventStop(
                                  $event,
                                  {}
                                )
                              }
                            }
                          })
                        : _vm._e(),
                      _vm._v(" "),
                      !_vm.entry.isNew && _vm.entry.meta.can_invalidate
                        ? _c("ItpButton", {
                            attrs: {
                              "dropdown-item": "",
                              text: _vm._f("pgettext")(
                                "Invalidate",
                                "BtnLockText"
                              ),
                              tooltip: _vm._f("pgettext")(
                                "Invalidate",
                                "BtnLockTooltip"
                              ),
                              variant: "default"
                            },
                            on: {
                              click: function($event) {
                                $event.preventDefault()
                                $event.stopPropagation()
                                return _vm.evh_2383909669375364_clickPreventStop(
                                  $event,
                                  {}
                                )
                              }
                            }
                          })
                        : _vm._e(),
                      _vm._v(" "),
                      !_vm.entry.isNew && _vm.entry.meta.can_revoke_invalidation
                        ? _c("ItpButton", {
                            attrs: {
                              "dropdown-item": "",
                              text: _vm._f("pgettext")(
                                "Revoke invalidated",
                                "BtnLockText"
                              ),
                              tooltip: _vm._f("pgettext")(
                                "Revoke invalidated",
                                "BtnLockTooltip"
                              ),
                              variant: "default"
                            },
                            on: {
                              click: function($event) {
                                $event.preventDefault()
                                $event.stopPropagation()
                                return _vm.evh_2342151935932928_clickPreventStop(
                                  $event,
                                  {}
                                )
                              }
                            }
                          })
                        : _vm._e(),
                      _vm._v(" "),
                      !_vm.entry.isNew && !_vm.entry.isReadOnly
                        ? _c("BtnDeleteResource", {
                            attrs: {
                              "no-icon": "",
                              "dropdown-item": "",
                              resource: _vm.entry,
                              tooltip: _vm._f("pgettext")(
                                "Delete entry",
                                "Register"
                              )
                            },
                            on: {
                              success: function($event) {
                                return _vm.evh_2498310591257107_success(
                                  $event,
                                  {}
                                )
                              }
                            }
                          })
                        : _vm._e()
                    ],
                    1
                  )
                : _vm._e()
            ],
            1
          )
        ],
        1
      )
    : _vm._e()
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }